<template>
	<div class="mx-auto flex max-w-7xl flex-col items-center">
		<HeadingLarge
			class="text-fluid-5xl! max-w-125 text-center italic xl:max-w-200"
			:richTextHtml="richTextHtml"
		/>

		<div class="flex flex-wrap justify-center pb-10">
			<PolicyBenefitsCard
				v-for="card in blok?.policyCards"
				:key="card._uid"
				:blok="card"
				class="w-full md:w-1/2 lg:w-1/3"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import HeadingLarge from '../presentation/HeadingLarge.vue'
import PolicyBenefitsCard from './SbPolicyBenefitsCard.vue'
import type { PolicyBenefitsSlideStoryblok } from '@/sbTypes'
import { renderRichText } from '@storyblok/vue'
import { computed, type PropType } from 'vue'

const props = defineProps({
	blok: Object as PropType<PolicyBenefitsSlideStoryblok>,
})

const richTextHtml = computed(
	() => renderRichText(props.blok?.headingLarge) ?? ''
)
</script>
